import {Userpilot} from 'userpilot';
import config from "../config/environment"

const userpilotToken = config.userpilotToken;

console.log("[Userpilot] token exists:", Boolean(userpilotToken));
console.log("[Userpilot] token prefix:", userpilotToken && userpilotToken.slice(0, 4));

let initialized = false;
let storeSubscribed = false;
let historySubscribed = false;
let identifiedUserId = null;

const getUserId = auth => auth && auth.user_id ? String(auth.user_id) : null;

const getUserRoles = auth => auth.roles || [];

const getUserRoleProperties = auth => {
    const roles = getUserRoles(auth);

    return roles.reduce(
        (properties, role) => {
            properties[`has_role_${role}`] = true;
            return properties;
        },
        {
            roles: roles.join(", ")
        }
    );
};

const getUserProperties = auth => ({
    email: auth.email,
    name: auth.name,
    client: auth.client,
    client_id: auth.client_id,
    employee_id: auth.employee_id,
    ...getUserRoleProperties(auth),
});

const identifyUser = store => {
    if (!initialized) {
        return;
    }

    const auth = store.getState().auth;
    const userId = auth && auth.isAuthenticated && getUserId(auth);

    if (userId && userId !== identifiedUserId) {
        Userpilot.identify(userId, getUserProperties(auth));
        identifiedUserId = userId;
        Userpilot.reload();
    }

    if (!userId && identifiedUserId) {
        Userpilot.clean();
        identifiedUserId = null;
    }
}

const reload = () => {
    if (initialized && identifiedUserId) {
        Userpilot.reload();
    }
}

export const setupUserpilot = (history, store) => {
    if (!userpilotToken) {
        return;
    }

    if (!initialized) {
        Userpilot.initialize(userpilotToken);
        initialized = true;
    }

    identifyUser(store);

    if (!storeSubscribed) {
        store.subscribe(() => identifyUser(store));
        storeSubscribed = true;
    }

    if (!historySubscribed) {
        reload();
        history.listen(reload);
        historySubscribed = true;
    }
}
